import 'twin.macro';
import React from 'react';
import { EDTSearchResult } from '@teetsh/app/src/containers/Search/types';
import { format } from '@teetsh/app/src/utils/time/format';
import { DescriptionList } from '@teetsh/app/src/components/DescriptionList';
import isValid from '@teetsh/app/src/utils/time/isValid';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useTranslation } from 'react-i18next';

interface Props {
  edt: EDTSearchResult;
}

export function EDTPreview(props: Props) {
  const { edt } = props;
  const { locale } = useUser();
  const { t } = useTranslation(['common']);

  return (
    <div tw="p-6">
      <div tw="text-xl font-bold mb-4">{edt.name}</div>

      <DescriptionList>
        {isValid(edt.createdAt) && (
          <DescriptionList.Item label={t('common:search.results.createdAt')}>
            {format(edt.createdAt, locale, 'eeee dd MMMM yyyy à hh:mm')}
          </DescriptionList.Item>
        )}
        {(edt?.classroomNames || []).length > 0 && (
          <DescriptionList.Item label={t('common:search.results.classes')}>
            {(edt?.classroomNames || []).join(', ')}
          </DescriptionList.Item>
        )}
        <DescriptionList.Item label={t('common:search.results.nbSeances')}>
          {edt.nbOfSeances}
        </DescriptionList.Item>
      </DescriptionList>
    </div>
  );
}
